import { createIcon } from 'src/components/icons/icon-utils';

export const ScrollLeftIcon = createIcon({
  path: 'M 0.531362 3.19322 C -0.01712 3.5926 -0.017121 4.41063 0.531362 4.81001 L 4.29406 7.54984 C 4.95497 8.03108 5.8827 7.55899 5.8827 6.74144 L 5.8827 1.26178 C 5.8827 0.444232 4.95497 -0.027854 4.29406 0.453388 L 0.531362 3.19322 Z',
  viewBox: '0 0 6 8',
});
